import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@store";

const initialState = {
  alreadyEnrolled: false,
};

export type ReturningUserSurveyState = typeof initialState;

// ### Reducers
const returningUserSurveySlice = createSlice({
  name: "returningUserSurvey",
  initialState,
  reducers: {
    setAlreadyEnrolled(
      state,
      { payload }: PayloadAction<ReturningUserSurveyState["alreadyEnrolled"]>
    ) {
      state.alreadyEnrolled = payload;
    },
  },
});

const { actions } = returningUserSurveySlice;
export const { setAlreadyEnrolled } = actions;
export default returningUserSurveySlice.reducer;

export const selectAlreadyEnrolled = () => (state: RootState) =>
  state.returningUserSurvey.alreadyEnrolled;

export namespace ReturningUserSurvey {
  export type ChartType =
    | "neutral"
    | "score-down-1"
    | "score-down-2"
    | "charged-off";
  export function generateChartDataPoints(chartType: ChartType) {
    if (
      chartType === "score-down-1" ||
      chartType === "score-down-2" ||
      chartType === "charged-off"
    ) {
      return [
        {
          date: 0,
          value: 40,
          withKikoff: 40,
        },
        {
          date: 22,
          value: 50,
          withKikoff: 50,
        },
        {
          date: 48,
          value: 60,
          withKikoff: 60,
        },
        {
          date: 48,
          value: 60,
          withoutKikoff: 60,
          tooltip:
            chartType === "score-down-1"
              ? "left-kikoff"
              : chartType === "charged-off"
              ? "stopped-paying"
              : null,
        },
        {
          date: 68,
          value: 25,
          withoutKikoff: 25,
        },
        {
          date: 48,
          value: 100,
          fullRed: 100,
        },
        {
          date: 68,
          value: 100,
          fullRed: 100,
        },
        {
          date: 68,
          value: 25,
          forecasted: 25,
          tooltip: chartType === "charged-off" ? "resume-today" : "today",
        },
        {
          date: 85,
          value: 45,
          forecasted: 45,
        },
        {
          date: 98,
          value: 75,
          forecasted: 75,
          tooltip: chartType === "score-down-2" ? "with-kikoff" : null,
        },
        {
          date: 68,
          value: 100,
          full: 100,
        },
        {
          date: 98,
          value: 100,
          full: 100,
        },
      ];
    }
    return [
      {
        date: 0,
        value: 20,
        withKikoff: 20,
      },
      {
        date: 18,
        value: 30,
        withKikoff: 30,
      },
      {
        date: 34,
        value: 40,
        withKikoff: 40,
        tooltip: "left-kikoff",
      },
      {
        date: 34,
        value: 40,
        neutral: 40,
      },
      {
        date: 50,
        value: 36,
        neutral: 36,
      },
      {
        date: 65,
        value: 32,
        neutral: 32,
        tooltip: "today",
      },
      {
        date: 65,
        value: 32,
        forecasted: 32,
      },
      {
        date: 80,
        value: 45,
        forecasted: 45,
      },
      {
        date: 97,
        value: 80,
        forecasted: 80,
        tooltip: "with-kikoff",
      },
      {
        date: 65,
        value: 100,
        full: 100,
      },
      {
        date: 97,
        value: 100,
        full: 100,
      },
    ];
  }
}
